/**
 * 颜色类型
 */
export const COLOR = {
  brand: "#409EFF",
  brand_bg: "#b3d8ff",
  success: "#67C23A",
  success_bg: "#c2e7b0",
  warning: "#E6A23C",
  warning_bg: "#fdf6ec",
  danger: "#F56C6C",
  danger_bg: "#fbc4c4",
  info: "#909399",
  info_bg: "#d3d4d6",
};
/**
 * 媒体类型
 */
export const MIME_TYPE = [
  { label: "图片", value: "IMAGE" },
  { label: "音频", value: "AUDIO" },
  { label: "视频", value: "VIDEO" },
  { label: "其它", value: "OTHER" },
];

/**
 * 图片类型
 */
export const IMAGE_TYPE = ["JPEG", "JPG", "PNG"];

/**
 * 音频类型
 */
export const AUDIO_TYPE = ["MP3", "OGG", "M4A"];

/**
 * 视频类型
 */
export const VIDEO_TYPE = ["MP4", "3GP", "AMR"];

/**
 * 产业类型/技术领域
 */
export const INDUSTRY_TYPE = [
  { label: "新能源汽车", value: "1" },
  { label: "装备制造", value: "2" },
  { label: "生物医药", value: "3" },
  { label: "现代食品", value: "4" },
  { label: "新材料(绿色建材)", value: "5" },
  { label: "信息创新(数字经济)", value: "6" },
  { label: "现代物流", value: "7" },
];

/**
 * 发布状态
 */
export const PUBLISH_STATUES = [
  { label: "未发布", value: "UnPublished", intVal: 1 },
  { label: "已发布", value: "Published", intVal: 2 },
  // { label: '已撤回', value: 'Revoked' },
];

/**
 * 审核状态
 */
export const AUDIT_STATUS = [
  { label: "未审核", value: "UnAudited" },
  { label: "审核通过", value: "Pass", color: COLOR.success },
  { label: "审核失败", value: "Reject", color: COLOR.danger },
];

/**
 * 政策类型
 */
export const POLICY_TYPE = [
  { label: "政策信息", value: "1" },
  { label: "政策解读", value: "2" },
  { label: "数字化案例", value: "3" },
];

/**
 * 新闻类型
 */
export const NEWS_TYPE = [
  { label: "中心资讯", value: "1" },
  { label: "行业资讯", value: "2" },
  { label: "前沿技术", value: "3" },
];

/**
 * 培训实训类型
 */
export const TRAINING_PRACTICE_TYPE = [
  { label: "科普认知", value: "1" },
  { label: "技术培训", value: "2" },
  { label: "实训空间", value: "3" },
  { label: "技能大赛", value: "4" },
];

/**
 * 应用类型
 */
export const APP_TYPE = [
  { label: "工业互联网平台类", value: "1" },
  { label: "智慧工厂类", value: "2" },
  { label: "智慧园区", value: "3" },
  { label: "云资源服务", value: "4" },
  { label: "开发者中心", value: "5" },
];

/**
 * 供需类型
 */
export const SUPPLY_DEMAN_TYPE = [
  { label: "供应信息", value: 1 },
  { label: "需求信息", value: 2 },
];

/**
 * 对接状态
 */
export const DOCKING_STATUS = [
  { label: "对接中", value: 1, color: COLOR.warning, pageColor: COLOR.brand },
  { label: "对接完成", value: 2, color: COLOR.success, pageColor: COLOR.success },
  { label: "对接失败", value: 3, color: COLOR.danger, pageColor: COLOR.danger },
];

/**
 * 成果成熟度
 */
export const ACHIEVEMENT_MATURITY = [
  { label: "正在研发", value: 1 },
  { label: "已有样品", value: 2 },
  { label: "通过小试", value: 3 },
  { label: "可以量产", value: 4 },
];

/**
 * 转让方式
 */
export const TRANSFER_METHOD = [
  { label: "完全转让", value: 1 },
  { label: "许可转让", value: 2 },
  { label: "技术入股", value: 3 },
];

/**
 * 转化状态
 */
export const TRANSFORMATION_STATUS = [
  { label: "暂无沟通", value: 0, backgroundColor: COLOR.info_bg, pageColor: COLOR.info, color: COLOR.info },
  { label: "转化中", value: 1, backgroundColor: COLOR.brand_bg, pageColor: COLOR.brand, color: COLOR.warning },
  { label: "已转化", value: 2, backgroundColor: COLOR.success_bg, pageColor: COLOR.success, color: COLOR.success },
  { label: "转化失败", value: 3, backgroundColor: COLOR.danger_bg, pageColor: COLOR.danger, color: COLOR.danger },
];

/**
 * 模块类型(对应文章类型接口)
 */
export const MODULE_TYPE = [
  { label: "新闻资讯", value: "News" },
  { label: "政策相关", value: "Policy" },
  { label: "成功案例", value: "Cases" },
  { label: "培训实训", value: "Training" },
];

/**
 * 模块类型
 */
export const ENTERPRISE_TYPE = [
  { label: "服务商", value: "1" },
  { label: "高等院校", value: "2" },
  { label: "科研机构", value: "3" },
];

// admin start
/**
 * 性别
 */
export const SEX_TYPE = [
  { label: "男", value: "1" },
  { label: "女", value: "2" },
];

/**
 * 账户类型
 */
export const ACCOUNT_TYPE = [
  { label: "个人账户", value: "Personal", intVal: "1" },
  { label: "企业账户", value: "Enterprise", intVal: "2" },
  { label: "专家账户", value: "Expert", intVal: "3" },
];

/**
 * 账户认证/审核状态
 */
export const ACCOUNT_AUDIT_STATUS = [
  { label: "未认证", value: "UnSubmit" },
  { label: "审核中", value: "Submited" },
  { label: "已认证", value: "Pass" },
  { label: "认证失败", value: "Reject" },
];

/**
 * 发布审核状态
 * 入驻状态-joinStatus
 */
export const PUBLISH_AUDIT_STATUS = [
  { label: "未发布", value: "UnSubmit", joinStatus: "未提交", color: COLOR.info },
  { label: "审核中", value: "Submited", joinStatus: "审核中", color: COLOR.warning },
  { label: "已驳回", value: "Reject", joinStatus: "入驻失败", color: COLOR.danger },
  { label: "已审核", value: "Pass", joinStatus: "已入驻", color: COLOR.success },
];

/**
 * 发布状态(Admin)
 */
export const ADMIN_PUBLISH_STATUES = [
  { label: "未发布", value: "UnPublished" },
  { label: "审核中", value: "Submited" },
  { label: "已发布", value: "Published" },
  { label: "已撤回", value: "Revoked" },
];

/**
 * 个人证件类型
 */
export const PERSONAL_ID_TYPE = [
  { label: "中国居民身份证", value: "1" },
  { label: "护照", value: "2" },
  { label: "其它", value: "3" },
];

/**
 * 企业证件类型
 */
export const ENTERPRISE_ID_TYPE = [
  { label: "统一社会信用代码", value: "1" },
  { label: "其他", value: "2" },
];

/**
 * 企业类型organization
 */
export const ENTERPRISE_ORGANIZAION_TYPE = [
  { value: "1", label: "国有控股" },
  { value: "2", label: "民营控股" },
  { value: "3", label: "外商控股" },
  { value: "4", label: "事业单位" },
  { value: "5", label: "民营非盈利组织" },
];

// admin end

/**
 * 申报方式
 */
export const CHANNEL_TYPE = [
  { label: "自行申报", value: "1" },
  { label: "辅助申报", value: "2" },
];

/**
 * 申报状态
 */
export const CHANNEL_AUDIT_TYPE = [
  { label: "申报中", value: "Submited", color: COLOR.warning },
  { label: "申报失败", value: "Reject", color: COLOR.danger },
  { label: "申报成功", value: "Pass", color: COLOR.success },
];

/**
 * 支付类型
 */
export const PAY_TYPE = [
  { label: "微信", value: "微信", icon: require("@/assets/images/wx_pay.png") },
  { label: "支付宝", value: "支付宝", icon: require("@/assets/images/zfb_pay.png") },
  { label: "对公转账", value: "对公转账", icon: require("@/assets/images/dgzz_pay.png") },
];

/**
 * 应用开通状态
 */
export const APP_OPEN_TYPE = [
  { label: "待开通", value: "待开通", color: COLOR.warning },
  { label: "已开通", value: "已开通", color: COLOR.success, overdueDayColor: COLOR.danger },
  { label: "已关闭", value: "已关闭", color: COLOR.info },
];

/**
 * 应用开通状态-加已逾期
 */
export const APP_OPEN_TYPE_ALL = [...APP_OPEN_TYPE, { label: "已逾期", value: "已逾期", color: COLOR.danger }];

/**
 * 支付状态
 */
export const PAY_STATUS = [
  { label: "未支付", value: "未支付", color: COLOR.warning },
  { label: "用户已取消", value: "用户已取消", color: COLOR.info },
  { label: "支付成功", value: "支付成功", color: COLOR.success },
  { label: "已退款", value: "已退款", color: COLOR.danger },
  { label: "超时已关闭", value: "超时已关闭", color: COLOR.info },
  { label: "待确认", value: "待确认", color: COLOR.warning },
];
